import React, { useEffect, useRef, useState } from 'react';
import { Text, StyleSheet, View, TouchableOpacity } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';

import ModalizeBase from '@web-components/modals/ModalizeBase';
import Colors from '~global/Colors';
// import { data as Fonts } from '~global/Fonts';
import LoginScreen from '@web/screens/LoginScreen';
import { HeaderMobile } from '@web-components/common/Layout';
import { storeAsyncData, getAsyncData } from '~global/helpers';
import LoginHeader from '@web-components/headers/LoginHeader';
import { isNative, isWeb } from '~global/screens';
import WithLocalSvg from '@web-components/common/WithLocalSvg';

const key = '@storage_header';

const ModalLogin = function (props) {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const show = useSelector((state) => state.modal.login.isShow);
  const navigation = props.navigation?.current || null;
  const [showHeaderLogin, setShowHeaderLogin] = useState(false);

  const register = () => {
    onClose();
    if (navigation) {
      navigation.navigate('SignupScreen');
    }
  };

  const onClose = () => dispatch({ type: 'MODAL/HIDE', modalName: 'login' });

  useEffect(() => {
    if (show) {
      modalizeRef?.current?.open();
    } else {
      modalizeRef?.current?.close();
    }
  }, [show]);

  useEffect(() => {
    getAsyncData(key).then((value) => {
      if (value) {
        setShowHeaderLogin(false);
      } else {
        setShowHeaderLogin(true);
      }
    });
  }, [showHeaderLogin]);

  return (
    <ModalizeBase
      fullScreen={global.isMobileWeb}
      ref={modalizeRef}
      modalStyle={isWeb ? styles.modal : styles.modalMobile}
      onClose={onClose}>
      {showHeaderLogin && global.isMobileWeb && (
        <LoginHeader
          onClose={() => {
            storeAsyncData(key, true);
            setShowHeaderLogin(false);
          }}
        />
      )}
      {!showHeaderLogin && global.isMobileWeb && (
        <HeaderMobile title="Login" leftAction={onClose} withBorder />
      )}
      {isWeb && <Text style={styles.modalTitle}>Login</Text>}
      <View style={global.isMobileWeb && styles.modalContainerMobile}>
        {global.isMobileWeb && (
          <View style={styles.logoWrapper}>
            <WithLocalSvg
              key="logoLilla"
              width={145}
              height={25}
              asset={require('~assets/img/common/new-lilla-text-logo.svg')}
            />
          </View>
        )}
        <LoginScreen navigation={navigation || {}} />
        <View style={styles.registerContainer}>
          <Text style={styles.registerTitle}>
            New on Lilla?
            <TouchableOpacity style={styles.registerLink} onPress={register}>
              <Text>Register now!</Text>
            </TouchableOpacity>
          </Text>
        </View>
      </View>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  logoWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    marginBottom: 32,
  },
  modal: {
    width: 376,
    height: 'auto',
    maxHeight: 500,
    padding: 24,
  },
  modalMobile: {
    height: '100%',
    minHeight: '100%',
    width: '100%',
  },
  modalTitle: {
    fontFamily: 'figtree-bold',
    fontSize: 18,
    color: Colors.purple7,
    textAlign: 'center',
    marginBottom: 24,
  },
  modalContainerMobile: {
    padding: 24,
    height: isNative ? 'auto' : 'calc(100vh - 80px)',
  },
  registerContainer: {
    marginTop: 24,
    textAlign: 'center',
  },
  registerLink: {
    color: Colors.purple14,
    fontFamily: 'figtree-bold',
    textDecorationLine: 'underline',
    paddingLeft: 5,
  },
  registerTitle: {
    color: Colors.black0,
    fontSize: 15,
    fontFamily: 'figtree-medium',
  },
});

export default ModalLogin;
